module.exports = __webpack_public_path__ + "img/勇丽调味-品牌logo.136b8d4a.jpg";